import { render, staticRenderFns } from "./IconBanOutline.vue?vue&type=template&id=74cc82bc"
import script from "./IconBanOutline.vue?vue&type=script&lang=js"
export * from "./IconBanOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports